// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import styled from 'styled-components';
export var ContentSuggestions = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-u92vq9-0"
})(["\n  &::-webkit-scrollbar {\n    width: 0.8rem;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: var(--color-neutral-dark-700, #73757a);\n    border-radius: 2rem;\n  }\n"]);